export default "__VITE_PUBLIC_ASSET__2a3ae97d__"